module.exports = __webpack_public_path__ + "static/media/theme-color-hint-3.24c5c41f.png";